"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";

class SupplementDocumentReview extends BaseModel {
  static getModelClassName() {
    return "SupplementDocumentReview";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/supplement-document-reviews"
    );
  }

  getAdminPath() {
    return "/orders/" + this.id;
  }

  static approve(orderUuid, callback) {
    SupplementDocumentReview._send(orderUuid + "/approve", {}, callback);
  }

  static reject(orderUuid, callback) {
    SupplementDocumentReview._send(orderUuid + "/reject", {}, callback);
  }

  static bulkApprove(orderUuids, callback) {
    SupplementDocumentReview._send(
      "bulk-approve",
      { orderUuids: orderUuids },
      callback
    );
  }

  static bulkReject(orderUuids, callback) {
    SupplementDocumentReview._send(
      "bulk-reject",
      { orderUuids: orderUuids },
      callback
    );
  }

  // The single-order actions take no meaningful body, but the request data must still be an
  // object: ApiRequest omits the body entirely when it is null, and a POST with a truly empty
  // body is rejected with a 400 by the reverse proxy before it ever reaches the API.
  static _send(pathSuffix, requestData, callback) {
    const requestUrl =
      SupplementDocumentReview.getApiPathForSearch() + "/" + pathSuffix;

    ApiRequest.send("POST", requestUrl, requestData).onComplete((response) => {
      callback(response);
    });
  }
}

export default SupplementDocumentReview;
